<template>
	<div
		:class="['c-reading-divider', { expand: expand === true }]"
		v-if="visible"
	>
		<div class="c-reading-divider__sidebar">&nbsp;</div>
		<div class="c-reading-divider__main">
			<span class="muted">{{ title }}</span>
		</div>
	</div>
</template>

<script>
import tt from '@/lib/trim-text.js';
import youtubeHelper from '@/lib/youtube-helper.js';
import avatar from '@/components/ui/avatar.vue';
import scrubber from '@/components/ui/scrubber.vue';
import TextRenderer from '@/components/dashboard/text-renderer';
import BookmarkRenderer from '@/components/dashboard/bookmark-renderer';
import CommentRenderer from '@/components/dashboard/comment-renderer';
import ListControls from '@/components/dashboard/list-controls';

import moment from 'moment';
import {
	CheckIcon,
	MessageCircleIcon,
	FileTextIcon,
	BookmarkIcon,
	CodeIcon,
	Edit2Icon,
} from 'vue-feather-icons';

export default {
	components: {
		CheckIcon,
		MessageCircleIcon,
		FileTextIcon,
		BookmarkIcon,
		CodeIcon,
		avatar,
		Edit2Icon,
		scrubber,
		TextRenderer,
		BookmarkRenderer,
		CommentRenderer,
		ListControls,
	},
	data: function () {
		var obj = {
			expand: false,
			wordCount: 72,
			commentCount: 140,
		};
		return obj;
	},
	props: [
		'note',
		'showBucket',
		'headerKey',
		'showAvatar',
		'forceOpen',
		'title',
	],
	computed: {
		visible: function () {
			if (this.forceOpen) {
				return true;
			}
			if (this.$store.getters['ui/isHeaderKeyHidden'](this.headerKey)) {
				return true;
			} else {
				return false;
			}
		},
		buckets: function () {
			return this.$store.getters['bucket/buckets'];
		},
		bucket: function () {
			if (this.note.bucket) {
				return this.$store.getters['bucket/bucket'](this.note.bucket);
			} else {
				return false;
			}
		},
		selectedNotes: function () {
			return this.$store.getters['note/selectedNotes'];
		},
		isSelected: function () {
			if (this.selectedNotes.length < 1) {
				return false;
			}
			if (this.selectedNotes.includes(this.note.id)) {
				return true;
			} else {
				return false;
			}
		},
		isVideo: function () {
			if (this.note.meta && this.note.meta.video && this.note.meta.resource) {
				return true;
			} else {
				return false;
			}
		},
		isYoutubeVideo: function () {
			if (
				this.isVideo &&
				this.note.meta.resource &&
				this.note.meta.resource.service === 'youtube'
			) {
				return true;
			} else {
				return false;
			}
		},
		videoThumbnail: function () {
			return `http://img.youtube.com/vi/${this.note.meta.resource.id}/mqdefault.jpg`;
		},
		scrubberStyle: function () {
			let style = {};
			if (this.isVideo) {
				let currentSeconds = youtubeHelper.timeToSeconds(
					this.note.meta.video.timestamp.time
				);
				let totalSeconds = youtubeHelper.timeToSeconds(
					this.note.meta.video.timestamp.totalTime
				);
				let pos = youtubeHelper.scaleValue(
					currentSeconds,
					[0, totalSeconds],
					[0, 100]
				);
				style.left = pos + '%';
			}
			return style;
		},
		date: function () {
			var m = moment(this.note.createdAt).fromNow();
			return m;
		},
		bookmark: function () {
			if (this.note.meta && this.note.meta.bookmark) {
				return true;
			} else {
				return false;
			}
		},
		file: function () {
			if (this.note.meta && this.note.meta.file) {
				return true;
			} else {
				return false;
			}
		},
		code: function () {
			if (this.note.type === 'code') {
				return true;
			} else {
				return false;
			}
		},
		comment: function () {
			if (this.note.comment && this.note.comment.raw) {
				return this.note.comment.html;
			} else {
				return false;
			}
		},
		beautifyLink: function () {
			var href = this.note.href;
			if (!href) {
				return '';
			}
			href = href.replace('https://', '');
			href = href.replace('http://', '');
			href = href.split('?');
			href = href[0];
			href = tt(href, 32, 'char');
			return href;
		},
	},
	methods: {
		onDragend: function (e) {
			this.$store.dispatch('dashboard/dragStopped');
		},
		onDragstart: function (e) {
			this.$store.dispatch('dashboard/dragStarted');
			e.dataTransfer.setData('text', this.note.id);
		},
		onBlur: function () {
			this.expand = false;
		},
		onFocus: function () {
			this.expand = true;
			this.$emit('onPreview');
		},
		getTitle: function (str) {
			str = str.split('|');
			if (str[1]) {
				var temp2 = str[0];
				var temp = [str.shift(), str.join('|')];
				return `${temp2}<br /> <span class="muted">${str}</span>`;
			} else {
				return str[0];
			}
		},
		onSelect: function (e) {
			let shiftSelect = false;
			if (e.shiftKey) {
				this.$emit('shiftSelect', this.note);
			} else if (e.ctrlKey) {
				this.$emit('ctrlSelect', this.note);
			} else {
				this.$store.commit('note/TOGGLE_SELECTION', this.note);
			}
		},
		onClick: function (action, el) {
			if (action === 'external-link') {
				this.onExternalLink(this.note.href);
			}
			if (action === 'open') {
				this.$store.dispatch('dashboard/setSelectedNote', this.note.id);
			}
			if (action === 'comment') {
				this.$emit('comment', this.note);
			}
			//this.$emit("onPreview");
		},
		onExternalLink: function (url) {
			window.open(url, '_blank');
		},
	},
};
</script>

<style lang="scss">
.c-reading-divider {
	display: flex;
	position: relative;
	width: calc(100% - 10px);
	margin-top: 0;
	margin-bottom: var(--spacer-sm);
	min-height: 31px;
	transition: background-color 100ms linear;

	&:focus {
		outline: none;
	}

	.badge {
		.muted {
			display: none;
		}
	}

	&__sidebar {
		position: relative;
		min-width: 40px;
		width: 40px;
		display: flex;
		justify-content: center;
	}

	&__main {
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin-left: var(--spacer-sm);
		flex-grow: 1;
		font-size: var(--font-size-xs);

		border-bottom: var(--g3) solid 2px;
	}
}
</style>
